Vue.component('ack-downloadables', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-downloadables',
	mixins: [languageMixins],
	created() {
		if (this.isUS_CA) {
			this.usCaFlyerLinkHandler(
				'sol-plus',
				'https://cdn.ackuretta.com/downloads/sol-plus/US_Digital_SOL%20Plus_Flyer.pdf',
			);
			this.usCaFlyerLinkHandler(
				'sol',
				'https://cdn.ackuretta.com/downloads/sol/US_Digital_SOL_Flyer.pdf',
			);
		}
	},
	mounted() {
		appLog.log('ack-downloadables mounted');
		this.setPageIsLoading(false);
	},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		...Vuex.mapGetters('localization', ['isUS_CA']),
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'downloadables-page',
			downloadables: [
				//ALPHA AI
				{
					id: 'alpha-ai',
					title: 'ALPHA AI',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/alpha-ai/Global_Digital_ALPHA%20AI_Flyer.pdf',
						},
						{
							title: 'Download ALPHA AI & Upgrade to Premium',
							link: 'https://ackuretta.com/pages/video-gallery?videoId=VoLbCy4sE-4',
						},
					],
				},
				//SOL Plus
				{
					id: 'sol-plus',
					title: 'SOL Plus',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/Global_Digital_SOL%20Plus_Flyer.pdf',
						},
						{
							title: 'Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/SOL%20Plus_QSG.pdf',
						},
						{
							title: 'Quick Start Guide with Concierge Service',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/SOL%20Plus%20with%20Concierge%20Service_QSG.pdf',
						},
						{
							title: 'Firmware Update',
							link: 'https://go.ackuretta.com/sol-plus-updating-firmware',
						},
						{
							title: 'Compatible Materials',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/SOL%20Plus%20Compatible%20Resins.pdf',
						},
						{
							title: 'Technical Specifications',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/SOL%20Plus_Technical%20Specifications%20Sheet.pdf',
						},
						{
							title: 'FAQs',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/SOL%20Plus_FAQ.pdf',
						},
						{
							title: 'CE Certification',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/CE_SOL%20Plus.pdf',
						},
						{
							title: 'Compare Printers',
							link: 'https://cdn.ackuretta.com/downloads/3dps/Ackuretta%20Printers%20Comparison_1.pdf',
						},
					],
				},
				//SOL
				{
					id: 'sol',
					title: 'SOL',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/sol/Global_Digital_SOL_Flyer.pdf',
						},
						{
							title: 'Brochure',
							link: 'https://cdn.ackuretta.com/downloads/sol/Global_Digital_SOL_Brochure.pdf',
						},
						{
							title: 'Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL_QSG.pdf',
						},
						{
							title: 'Quick Start Guide with Concierge Service',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL%20with%20Concierge%20Service_QSG_Website.pdf',
						},
						{
							title: 'Technical Specifications',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL_Technical%20Specifications%20Sheet.pdf',
						},
						{
							title: 'User Manual',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL%20User%20Manual.pdf',
						},
						{
							title: 'Firmware Update',
							link: 'https://go.ackuretta.com/sol-firmware-update',
						},
						{
							title: 'Compatible Materials',
							link: 'https://go.ackuretta.com/sol-compatible-materials/downloads',
						},
						{
							title: 'Compare Printers',
							link: 'https://cdn.ackuretta.com/downloads/3dps/Ackuretta%20Printers%20Comparison_1.pdf',
						},
						{
							title: 'FAQs',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL_FAQ.pdf',
						},
						{
							title: 'CE Certification',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL_CE.pdf',
						},
						{
							title: 'FCC Certification',
							link: 'https://cdn.ackuretta.com/downloads/sol/FCC_SOL.pdf',
						},
					],
				},
				//DENTIQ
				{
					id: 'dentiq',
					title: 'DENTIQ',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/Global_Digital_DENTIQ%20Flyer.pdf',
						},
						{
							title: 'Brochure',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/Global_Digital_DENTIQ_Brochure.pdf',
						},
						{
							title: 'Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/DENTIQ_QSG.pdf',
						},
						{
							title: 'User Manual',
							link: 'https://drive.google.com/file/d/1tqJ-7uMY9hSnPTHoKLyJRDcSUOC_tnH6/view?usp=sharing',
						},
						{
							title: 'Firmware Update',
							link: 'https://go.ackuretta.com/dentiq-firmware-update',
						},
						{
							title: 'Compatible Materials',
							link: 'https://go.ackuretta.com/dentiq-compatible-materials/downloads',
						},
						{
							title: 'Compare Printers',
							link: 'https://cdn.ackuretta.com/downloads/3dps/Ackuretta%20Printers%20Comparison_1.pdf',
						},
						{
							title: 'FAQs',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/DENTIQ_FAQ.pdf',
						},
						{
							title: 'CE Certification',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/PRO-OTH-190422-0013_DENTIQ%20120%20FreeShape%20120%20Veribuild%2079200%20CE%20Declaration%20of%20Conformity%20-%20ACKURETTA.pdf',
						},
						{
							title: 'FCC Certification',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/PRO-OTH-210910-0033_DENTIQ%20FCC%20Certificate.pdf.pdf',
						},
					],
				},
				//CLEANI Tank Plus
				{
					id: 'cleani-tank-plus',
					title: 'CLEANI with Tank Plus',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/cleani/Global_Digital_CLEANI_Flyer.pdf',
						},
						{
							title: 'Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/cleani-tank-plus/CLEANI%20with%20Tank%20Plus_QSG.pdf?v=latest',
						},
						{
							title: 'Technical Specifications',
							link: 'https://cdn.ackuretta.com/downloads/cleani-tank-plus/CLEANI%20Tank%20Plus_Technical%20Specifications%20Sheet.pdf',
						},
						{
							title: 'FAQs',
							link: 'https://cdn.ackuretta.com/downloads/cleani/CLEANI_FAQ.pdf',
						},
					],
				},
				//CLEANI Dual Tanks
				{
					id: 'cleani-dual-tanks',
					title: 'CLEANI with Dual Tanks',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/cleani/Global_Digital_CLEANI_Flyer.pdf',
						},
						{
							title: 'Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/cleani/CLEANI%20with%20Dual%20Tanks_QSG.pdf?v=latest',
						},
						{
							title: 'Technical Specifications',
							link: 'https://cdn.ackuretta.com/downloads/cleani/CLEANI%20Dual%20Tanks_Technical%20Specifications%20Sheet.pdf?v=latest',
						},
						{
							title: 'FAQs',
							link: 'https://cdn.ackuretta.com/downloads/cleani/CLEANI_FAQ.pdf',
						},
					],
				},
				//CURIE Plus & nfinity
				{
					id: 'curie-plus-nfinity',
					title: 'CURIE Plus & NFinity',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/Web_CURIE%20Plus%20Flyer.pdf',
						},
						{
							title: 'CURIE PLUS FAQ & Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/CURIE%20Plus_QSG.pdf?v=latest',
						},
						{
							title: 'NFinity FAQ & Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/Nfinity_QSG.pdf?v=latest',
						},
						{
							title: 'Technical Specifications',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/CURIE%20Plus_Technical%20Specifications%20Sheet.pdf',
						},
						{
							title: 'Firmware Update',
							link: 'https://go.ackuretta.com/curie-plus-firmware',
						},
						{
							title: 'How to Cure with Nitrogen',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/CURIE%20Plus_SOP.pdf?v=latest',
						},
						{
							title: 'Compatible Materials',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/CURIE%20Plus_Compatible_resins.pdf',
						},
						{
							title: 'Compare UV Ovens',
							link: 'https://cdn.ackuretta.com/downloads/3dps/uv_ovens_comparison.pdf',
						},
					],
				},
				//CURIE
				{
					id: 'curie',
					title: 'CURIE',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/curie/Global_Digital_CURIE_Flyer.pdf',
						},
						{
							title: 'Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/curie/CURIE%2024_11_2022.pdf',
						},
						{
							title: 'User Manual',
							link: 'https://cdn.ackuretta.com/downloads/curie/CURIE%20User%20Manual.pdf',
						},
						{
							title: 'Technical Specifications',
							link: 'https://cdn.ackuretta.com/downloads/curie/CURIE_Technical%20Specifications%20Sheet.pdf',
						},
						{
							title: 'Resin Library update',
							link: 'https://ackuretta.com/pages/curie-resin-library-update',
						},
						{
							title: 'Curing Values',
							link: 'https://cdn.ackuretta.com/downloads/curie/Post%20curing%20settings.pdf?v=2',
						},
						{
							title: 'Compare UV Ovens',
							link: 'https://cdn.ackuretta.com/downloads/3dps/uv_ovens_comparison.pdf',
						},
						{
							title: 'CE Certification',
							link: 'https://cdn.ackuretta.com/downloads/curie/CE%20document_curie2.pdf',
						},
					],
				},
				//CURO
				{
					id: 'curo',
					title: 'CURO',
					downloads: [
						{
							title: 'Brochure',
							link: 'https://cdn.ackuretta.com/downloads/curo/Global_Digital_CURO_Brochure.pdf?v=latest',
						},
						{
							title: 'Instructions for Use',
							link: 'https://cdn.ackuretta.com/downloads/curo/Instructions%20for%20Use.pdf',
						},
						{
							title: 'Application Booklet',
							link: 'https://go.ackuretta.com/application-booklet',
						},
						{
							title: 'Curing times',
							link: 'https://cdn.ackuretta.com/downloads/curo/CURO%20Resins%20Post%20Curing%20Times.pdf',
						},
					],
					materialSafetyDataSheet: [
						{
							title: 'Material Safety Data Sheet',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20ProGingiva%20-%20PRO-TD-241129-001%20-%20MSDS.pdf',
						},
						{
							title: 'Ortho Model',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Ortho%20Model%20-%20MSDS.pdf',
						},
						{
							title: 'Splint',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Pro%20Splint-%20MSDS.pdf',
						},
						{
							title: 'Gingiva',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Gingiva-%20MSDS.pdf',
						},
						{
							title: 'Crown',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Crown%20-%20MSDS.pdf',
						},
						{
							title: 'ProCast',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Pro%20Cast%20-%20MSDS.pdf',
						},
						{
							title: 'ProDenture',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Pro%20Denture%20-%20MSDS.pdf',
						},
						{
							title: 'IBT',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20IBT%20-%20MSDS.pdf',
						},
						{
							title: 'Guide',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Guide%20-%20MSDS.pdf',
						},
						{
							title: 'Tray',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Tray%20-%20MSDS.pdf',
						},
						{
							title: 'Model',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Model%20-%20MSDS.pdf',
						},
						{
							title: 'Element Model White',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Element%20Model%20White-%20MSDS.pdf',
						},
						{
							title: 'Element Model Beige',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Element%20Model%20Beige-%20MSDS.pdf',
						},
					],
				},
				{
					id: 'flow',
					title: 'FLOW',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/flow/Global_Digital_FLOW_Flyer.pdf?v=latest',
						},
						{
							title: 'C&B Instructions for Use',
							link: 'https://cdn.ackuretta.com/downloads/flow/IFU/FLOW_C&B_IFU.pdf',
						},
						{
							title: 'Denture Instructions for Use',
							link: 'https://cdn.ackuretta.com/downloads/flow/IFU/FLOW_Denture_IFU.pdf',
						},
						{
							title: 'Hard Splint Instructions for Use',
							link: 'https://cdn.ackuretta.com/downloads/flow/IFU/FLOW_Hard%20Splint_IFU.pdf',
						},
					],
					materialSafetyDataSheet: [
						{
							title: 'Material Safety Data Sheet',
							link: '',
						},
						{
							title: 'C&B',
							link: 'https://cdn.ackuretta.com/downloads/flow/MSDS/MSDS%20-%20FLOW%20C&B.pdf',
						},
						{
							title: 'Denture',
							link: 'https://cdn.ackuretta.com/downloads/flow/MSDS/MSDS%20-%20FLOW%20Denture.pdf',
						},
						{
							title: 'Hard Splint',
							link: 'https://cdn.ackuretta.com/downloads/flow/MSDS/MSDS%20-%20FLOW%20Hard%20Splint.pdf',
						},
					],
				},
			],
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
	methods: {
		usCaFlyerLinkHandler(productId, link) {
			this.downloadables
				.find((downloadable) => downloadable.id === productId)
				.downloads.find((download) => download.title === 'Flyer').link = link;
		},
	},
});
